import moment from "moment";
import React from "react";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import services from "../../../services";
import $ from "jquery";

const dateFormat = "DD-MM-YYYY HH:mm:ss";
const dateFormatNoTime = "DD-MM-YYYY";

let tableJson = {
    MarcasPendentes: {
        columnkeyMap: {
            //IdMarcaRequest: "Nº Processo",
            numeroPedido: "Nº Pedido",
            Marca: "Marca",
            NumeroMarca: "Código de Marca",
            TipoMarca: "Tipo de Marca",
            PropriedadeMarca: "Propriedade da Marca",
            Entidade: "Entidade",
            EntidadeRegisto: "Entidade de Registo",
            //Estado: "Estado",
            Validade: "Validade da Marca",
            ValidadeCedencia : "Validade de Cedência",
            //DataCriado: "Última Atualização",
            motivoRecusa: "Fundamentação da Decisão",
            Pais: "País"
           // ModificadoPor: "Alterado por"
            //TipoMarcaDescricao: "Propriedade da Marca Detalhe",
            //TipoMarcaDetalhe: "Tipo da Marca Detalhe",
            
            //EntidadaeNome: "Entidade",
            //IdEstado: "Estado",
            //DataCriado: "Submissão",
        },
        actionbuttons: {
            module: "marcas",
            title: "",
            action: "pending",
        },
        listApilink: "Marcas/ViewMarcas",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de processos pendentes ",
        //edit filters here
        filters: {
            codEstado: 6
        },
        groupfield: [],
    },
    MarcasApproved: {
        columnkeyMap: {
            numeroPedido: "Nº Pedido",
            Marca: "Marca",
            NumeroMarca: "Código de Marca",
            TipoMarca: "Tipo de Marca",
            PropriedadeMarca: "Propriedade da Marca",
            Entidade: "Entidade",
            EntidadeRegisto: "Entidade de Registo",
            Estado: "Estado",            
            Validade: "Validade da Marca",
            //DataCriado: "Última Atualização",
            //ModificadoPor: "Alterado Por",
            ValidadeCedencia : "Validade de Cedência",
            motivoRecusa: "Fundamentação da Decisão",
            Pais: "País"
            // IdMarcaRequest: "Nº Processo",
            // NumeroMarca: "Código de Marca",
            // NomeProprietario: "Entidade proprietária",
            // marca: "Marca",
            // TipoMarca: "Propriedade da Marca",
            // TipoMarcaDescricao: "Propriedade da Marca Detalhe",
            //date_expiry_of_brand: "Data de Expiração",
            // EntidadeCedida: "Cedida a",
            // entidadeBrandValidity: "Cedida até",
            //IdEstado: "Estado",
        },
        actionbuttons: {
            module: "marcas",
            action: "approved",
        },
        listApilink: "Marcas/ViewMarcas",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de Marcas ",
        //edit filters here
        filters: {
            codEstado: null
        },
        groupfield: [],
    },
    // MarcasHistory: {
    //     columnkeyMap: {
    //         IdMarcaRequest: "Nº Processo",
    //         NumeroMarca: "Código de Marca",
    //         NomeProprietario: "Entidade proprietária",
    //         marca: "Marca",
    //         tipo_de_marca: "Propriedade da Marca",
    //         TipoMarcaDescricao: "Propriedade da Marca Detalhe",
    //         date_approval: "Data de Aprovação",
    //         date_expiry_of_brand: "Data de Expiração",
    //         EntidadeCedida: "Cedida a",
    //         entidadeBrandValidity: "Cedida até",
    //         IdEstado: "Estado",
    //     },
    //     actionbuttons: {
    //         module: "marcas",
    //         action: "history",
    //     },
    //     listApilink: "Marcas/ViewMarcas",
    //     requestMethod: "get",
    //     notAction: false,
    //     totalPageHeading: "Histórico de pedidos",
    //     //edit filters here
    //     filters: {
    //         status: "history",
    //         processNumber: -1,
    //         brandCode: -1,
    //         brandName: null,
    //         entidadeNIF: null,
    //         entidadeName: null,
    //         brandValidFromDate: null,
    //         brandValidToDate: null,
    //     },
    //     groupfield: [],
    // },
};

let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 100,
};

class MarcasTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            linkData: tableJson[this.props.tableName],
            tlkState: null,
            telkikTable: null,
            error: null,
            totalcount: 0,
            showSearchMsg: false,
        };
    }

    componentDidMount() {
        this.defaultState();
    }

    componentDidUpdate(preProp) {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
            this.defaultState();
        }
    }

    defaultState = () => {
        let linkData = { ...tableJson };
        linkData = tableJson[this.props.tableName];
        this.setState(
            {
                linkData,
                tlkState: {
                    take: 10,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
            },
            () => this.getListData()
        );
    };

    getListData = async () => {
        if (!this.state.linkData) return;
        const request = this.getAllFilter();
        console.log("request 800 in the filet", request);
        const url = this.state.linkData.listApilink;
        const method = this.state.linkData.requestMethod;
        const response = await services.apiCall.requestApi(
            url,
            request,
            method
        );
        const columnkeyMap = this.state.linkData.columnkeyMap;
        if (response && response.length > 0) {
            response.sort((first, second) => {
                if (first.idMarcaRequest < second.idMarcaRequest) {
                    return -1;
                }
            });
            response.map((_row, index) => {
                Object.keys(columnkeyMap).map((key) => {
                    //for marcasPendentes
                    if (key === "Marca") {
                        _row[columnkeyMap[key]] = _row.marca;
                    } else if (key === "IdMarcaRequest") {
                        _row[columnkeyMap[key]] = _row.idMarcaRequest;
                    } else if (key === "NumeroMarca") {
                        _row[columnkeyMap[key]] = _row.numeroMarca;
                    }else if  (key === "Pais"){
                         _row[columnkeyMap[key]] = _row.pais;
                    }else if (key === "TipoMarca") {
                        _row[columnkeyMap[key]] = _row.tipoMarca;
                    } else if (key === "PropriedadeMarca") {
                        _row[columnkeyMap[key]] = _row.propriedadeMarca;
                    } else if (key === "Entidade") {
                        _row[columnkeyMap[key]] = _row.entidade;
                    } else if (key === "EntidadeRegisto") {
                        _row[columnkeyMap[key]] = _row.entidadeRegisto;
                    } else if (key === "Estado") {
                        _row[columnkeyMap[key]] = _row.estado;
                    } else if (key === "Validade") {
                        _row[columnkeyMap[key]] = moment(
                            _row.validade
                        ).format(dateFormatNoTime);
                    }else if (key === "ValidadeCedencia") {
                        if(_row.validadeCedencia != ""){
                            _row[columnkeyMap[key]] = moment(
                                _row.validadeCedencia
                            ).format(dateFormatNoTime);
                        }else{
                            _row[columnkeyMap[key]] = ""
                        }
                    } else if (key === "TipoMarcaDescricao") {
                        _row[columnkeyMap[key]] = _row.tipoMarcaDescricao;
                    } else if (key === "EntidadaeNome") {
                        _row[columnkeyMap[key]] = _row.entidadaeNome;
                    }else if(key === 'ModificadoPor'){
                        _row[columnkeyMap[key]] = _row.modificadoPor;
                    } else if (key === "IdEstado") {
                        _row[columnkeyMap[key]] =
                            _row.idEstado === 15
                                ? "Pendente"
                                : _row.idEstado === 13
                                ? "Aprovado"
                                : "Rejeitado";
                    } else if (key === "DataCriado") {
                        _row[columnkeyMap[key]] = moment(
                            _row.dataCriado
                        ).format(dateFormat);
                    } else if (key === "date_approval") {
                        _row[columnkeyMap[key]] = moment(
                            _row.dateOfApproval
                        ).format(dateFormat);
                    } else if (key === "date_expiry_of_brand") {
                        _row[columnkeyMap[key]] = moment(
                            _row.dateOfExpiration
                        ).format(dateFormat);
                    } else if (key === "tipo_de_marca") {
                        _row[columnkeyMap[key]] = _row.tipoMarca;
                    } else if (key === "entidadeBrandValidity") {
                        _row[columnkeyMap[key]] = moment(
                            _row.validadecendencia
                        ).format(dateFormatNoTime);
                    } else if (key === "NomeProprietario") {
                        _row[columnkeyMap[key]] = _row.nomeProprietario;
                    }
                    else if (key === "TipoMarcaDetalhe") {
                        _row[columnkeyMap[key]] = _row.tipoMarcaDetalhe;
                    }
                    else if (key === "EntidadeCedida") {
                        _row[columnkeyMap[key]] = _row.entidadeCedida;
                    }
                    //marcasHistory
                    else if (key === "verifiedBy") {
                        _row[columnkeyMap[key]] = _row.modificadoPor
                            ? _row.modificadoPor
                            : "nd";
                    } else if (key === "verifiedOn") {
                        _row[columnkeyMap[key]] = _row.dataModificado
                            ? _row.dataModificado
                            : "nd";
                    } else {
                        _row[columnkeyMap[key]] = _row[key] ? _row[key] : " ";
                    }
                });
            });
            console.log("response", response);
            window.localStorage.setItem('table_total', response.length);
            this.setState(
                {
                    data: response,
                    filterData: response,
                    showSearchMsg: false,
                    totalcount: response.length,
                },
                () => this.createTable()
            );
        } else {
            this.setState({
                showSearchMsg: true,
                telkikTable: null,
                totalcount: 0,
            });
        }
    };

    getAllFilter = () => {
        let request = Object.assign({}, listdefaultRequest);
        if (this.state.linkData.filters.codEstado != null){
            request.codEstado = this.state.linkData.filters.codEstado;
        }
        
        // if (this.props.applyedfilter) {
        //     request.filters = Object.assign(
        //         {},
        //         this.state.linkData.filters,
        //         this.props.applyedfilter
        //     );
        // }
        //delete request.filters.local;
        return request;
    };

    ActionPerform = (action, row) => {
            console.log(window.location.pathname, "row cen")
            var caminho = window.location.pathname
        if (action === "pending") {
           window.location.href = `/marcas_n_d_processo?&estado=${row.detalheURLEstado}&id=${row.detalheURLID}&tdp=Tipo de marca: ${row.detalheURLTipoMarca}&evaluator=1&processo=${row.detalheURLMarca}&pagina=${caminho}&IDEntidade=${row.detalheURLIDEntidade}`
        }else if (action === "approved") {
            window.location.href = `/marcas_n_d_processo?&estado=${row.detalheURLEstado}&id=${row.detalheURLID}&tdp=Tipo de marca: ${row.detalheURLTipoMarca}&evaluator=1&processo=${row.detalheURLMarca}&pagina=${caminho}&IDEntidade=${row.detalheURLIDEntidade}`
        }
    
    };

    createTable = () => {
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons || {};
            let telkikTable = (
                <TlkTable
                    date={new Date()}
                    noDownloadButton={this.state.linkData.noDownloadButton}
                    actionColumnName={this.state.linkData.actionColumnName}
                    groupfield={this.state.linkData.groupfield}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    notAction={this.state.linkData.notAction}
                    //tlkState={this.state.tlkState}
                    pageable={true}
                    collepsview={true}
                    viewFor="marcas"
                    deleteFunc={(id) => this.props.handleDelete(id)}
                    //tableFilters={(filter) => this.tableFilters(filter)}
                    list={this.state.filterData}
                    actionbuttons={actionbuttons}
                    MainModule="marcas"
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            let customfilters = this.getAllFilter();
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let tlkState = { ...tlfilter };
            let data = this.makeTlkFilters(
                tlfilter,
                columnkeyMap,
                customfilters
            );
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    render() {
        if (this.state.error) throw this.state.error;
        return (
            <>
                <div className="custom-k-grid table-section">
                    <div className="table-responsive">
                        {this.state.telkikTable && (
                            <>
                                <h3>
                                    {tableJson[this.props.tableName] &&
                                    tableJson[this.props.tableName]
                                        .totalPageHeading
                                        ? tableJson[this.props.tableName]
                                              .totalPageHeading +
                                          "(" +
                                          this.state.totalcount +
                                          ")"
                                        : `A pesquisa retornou ${this.state.totalcount} registos`}
                                </h3>
                                {this.state.telkikTable}
                            </>
                        )}

                        {this.state.totalcount == 0 && (
                            <div className="searct-found">
                                <img
                                    alt="Não foram identificados registos com os critérios indicados"
                                    className="img-fluid"
                                    src="imgs/data-rotulos.png"
                                />
                                {this.state.showSearchMsg ? (
                                    <p className="font-14">Não foram identificados registos com os critérios indicados</p>
                                ) : (
                                    <h3>
                                        Sem pedidos pendentes
                                    </h3>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default MarcasTable;
